import Vue from 'vue';

Vue.filter('user_role', (value) => {
  switch (value) {
    case 'admin':
      return 'administrator';
    case 'project_lead':
      return 'vodja projektov';
    case 'reviewer':
      return 'pregledovalec';
    default:
      return 'neznana';
  }
});

Vue.filter('ucfirst', (value) => {
  if (typeof value !== 'string') {
    return ''
  }

  return value.charAt(0).toUpperCase() + value.slice(1)
});
